<template>
    <vPartnerProductAccountPeriodComponent :postList="postList" v-if="flag"></vPartnerProductAccountPeriodComponent>
</template>
<script>
import vPartnerProductAccountPeriodComponent from '../../listComponent/basicdata/partnerProductAccountPeriod/partnerProductAccountPeriodComponent.vue';
export default {
    name: 'partnerProductAccountPeriodList',
    components: {
        vPartnerProductAccountPeriodComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                addBtn: true,
                ppa_code: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>